import { Animation } from "@story/story_assets";

document.addEventSelectorListener("click", "[data-masonry-filter]", function(event, target) {
	event.preventDefault();

	// Only one active button
	for (let element of document.querySelectorAll("[data-masonry-filter]")) {
		element.classList.remove("active");
	}
	target.classList.add("active");

	selectedIds = [];

	let id = target.getAttribute("data-masonry-filter");
	if (id) {
		selectedIds.push(id);
	}

	for (let element of document.querySelectorAll("[data-masonry-item]")) {
		let ids = element.getAttribute("data-masonry-item").split(",");
		let intersection = selectedIds.filter(value => ids.includes(value));
		let isActive = selectedIds.length == 0 || 0 < intersection.length;

		if (isActive) {
			Animation.fadeIn(element);
		}
		else {
			element.classList.add("d-none");
		}
	}

});
